"use client";

import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import type { FestivalDay } from "@/lib/types";
import { useScheduleBuilder } from "./schedule-context";
import { useScheduleData } from "./use-schedule-data";

export function ExportGridButton({
  festivalName,
  dateLabel,
  day,
  country,
}: {
  festivalName: string;
  dateLabel: string;
  day: FestivalDay;
  country: string;
}) {
  const [isExporting, setIsExporting] = useState(false);
  const { savedSetKeys } = useScheduleBuilder();
  const data = useScheduleData(day.attractions);

  if (!data || savedSetKeys.size === 0) return null;

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const { exportMyGrid } = await import("./export-my-grid");
      await exportMyGrid(data, {
        festivalName,
        dateLabel,
        savedSetKeys,
        eventId: day.event_id,
        country,
      });
    } catch (err) {
      console.error("PDF export failed:", err);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={isExporting}
      className="flex items-center gap-1.5 rounded-lg border border-neutral-700 px-3 py-1.5 font-mono text-[10px] font-bold tracking-wider text-neutral-400 transition-all hover:border-acid hover:text-acid disabled:opacity-50 cursor-pointer"
      title="Export my schedule as PDF"
    >
      {isExporting ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <Download className="h-3.5 w-3.5" />
      )}
      EXPORT PDF
    </button>
  );
}
